document.addEventListener("DOMContentLoaded", function() {

    // Favorite click
    // ==============
    const favoriteClick = (that) => {
        let active = that.classList.contains('active'),
            id_zs = that.getAttribute('data-id_zs');

        const data = {
            id_zs: id_zs,
            delete: active ? 1 : 0
        };

        let request = new XMLHttpRequest();
        request.open('GET', locale.url_favorite + '?' + dataToQueryString(data), true);

        request.onload = function() {
            if (this.status >= 200 && this.status < 400) {
                that.classList.toggle('active');
                that.closest('div').querySelector('.js-nemovitosti-takeout').classList.remove('active');
                if(this.response === 0){
                    document.querySelector('.js-favorite-link').style.display = 'none';
                    document.querySelector('.location_nemovitosti.action_favorite .estates-container').innerHTML = '<div class="alert alert-info"><p>V oblíbených nabídkách nemáte žádné další nabídky</p></div>';
                } else {
                    document.querySelector('.js-favorite-link').style.display = 'block';
                }

                document.querySelector('.js-favorite-link .count').textContent = this.response;
                if(document.body.classList.contains('action_favorite'))
                    that.closest('.js-estateListItem').parentNode.removeChild(that.closest('.js-estateListItem'));

            } else {
                that.style.backgound = 'red';
            }
        };
        request.send();
    }

    document.body.addEventListener('click', function (e) {
        if(!e.target.matches('.js-nemovitosti-favorite'))
            return;

        e.preventDefault();
        favoriteClick(this);
    });


    // TakeOut click
    // =============
    const takeoutClick = (that) => {
        let active = that.classList.contains('active'),
            id_zs = that.getAttribute('data-id_zs');

        const data = {
            id_zs: id_zs,
            delete: active ? 1 : 0
        };

        let request = new XMLHttpRequest();
        request.open('GET', locale.url_takeout + '?' + dataToQueryString(data), true);

        request.onload = function() {
            if (this.status >= 200 && this.status < 400) {
                that.classList.toggle('active');
                that.closest('div').querySelector('.js-nemovitosti-favorite').classList.remove('active');
                if(this.response === 0){
                    document.querySelector('.js-takeout-link').style.display = 'none';
                    document.querySelector('.location_nemovitosti.action_takeout .estates-container').innerHTML = '<div class="alert alert-info"><p>V odebraných nabídkách nemáte žádné další nabídky</p></div>';
                } else {
                    document.querySelector('.js-takeout-link').style.display = 'block';
                }

                document.querySelector('.js-takeout-link .count').textContent = this.response;
                that.closest('.js-estateListItem').parentNode.removeChild(that.closest('.js-estateListItem'));

            } else {
                that.style.backgound = 'red';
            }
        };
        request.send();
    }

    document.body.addEventListener('click', function (e) {
        if(!e.target.matches('.js-nemovitosti-takeout'))
            return;

        e.preventDefault();
        takeoutClick(this);
    });
});